export default {
  noResultFoundFor: 'No result found for',
  foundFromServerHint: 'Type keyword and press Enter to search in {appName}',
  notResultFoundFromServer: 'No results found',
  loading: 'loading...',
} as const;
